import { createSelector } from 'reselect';

import { frequentlyBoughtTogetherEngineList } from '@/domains/productDiscovery/Recommendation/selectors/productRecommendation';

import type { SpartacuxShoppingCartState } from '../../ShoppingCartState';
import * as translations from './translations';

export const selectA2CProductRecommendationConfigs = (
  state: Partial<SpartacuxShoppingCartState>,
) =>
  state.shoppingCart?.addToCartModal?.productRecommendation
    ?.recommendationsConfig;

export const selectA2CFrequentlyBoughtRecommendationsConfig = createSelector(
  [selectA2CProductRecommendationConfigs],
  (recommendations) =>
    recommendations?.find(
      (reco) =>
        reco?.engineName &&
        frequentlyBoughtTogetherEngineList.includes(reco?.engineName),
    ),
);

export const selectA2CProductRecommendations = (
  state: Partial<SpartacuxShoppingCartState>,
) => state.shoppingCart?.addToCartModal?.productRecommendation?.recommendations;

export const selectA2CFrequentlyBoughtRecommendations = createSelector(
  [selectA2CProductRecommendations],
  (recommendations) => {
    let playlist = recommendations?.find(
      (reco) =>
        reco.engineName &&
        frequentlyBoughtTogetherEngineList.includes(reco.engineName),
    );

    if (playlist) {
      playlist = {
        ...playlist,
        title: translations.oftenPurchasedTogether,
      };
    }

    return playlist;
  },
);

/**
 *
 * @param state Redux state
 * @returns state.shoppingCart.addToCartModal.productRecommendation.recommendations
 */
export const addToCartProductRecommendationsSelector = (
  state: Partial<SpartacuxShoppingCartState>,
) => state.shoppingCart?.addToCartModal?.productRecommendation?.recommendations;
